import { render } from "./SubprojectCard.vue?vue&type=template&id=fde67066&scoped=true"
import script from "./SubprojectCard.vue?vue&type=script&lang=js"
export * from "./SubprojectCard.vue?vue&type=script&lang=js"

import "./SubprojectCard.vue?vue&type=style&index=0&id=fde67066&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fde67066"]])

export default __exports__